export default {
	SET_TEMPLATE_ERROR: 'SET_TEMPLATE_ERROR',
	RESET_TEMPLATE_ERROR: 'RESET_TEMPLATE_ERROR'
};
